import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/base/buttons'
import {useLoginStore} from './login-store'

export const LoginDesktopServer = observer(() => {
  const [state, store] = useLoginStore()

  return (
    <div className="login-forget server">
      {!state.serverShow && (
        <div className="login-server-btn">
          {!state.serverSavedValue && (
            <div className="_link" onClick={() => store.setServerShow(true)}>
              {Lang.msg.enterBoxUrl}
            </div>
          )}

          {state.serverSavedValue && (
            <div>
              <span className="whitespace-nowrap">
                {Lang.msg.boxUrlIs(state.serverSavedValue)}
              </span>
              <span className="_link" onClick={() => store.setServerShow(true)}>
                {Lang.msg.change}
              </span>
              <span className="_link ml-4" onClick={store.serverClear}>
                {Lang.msg.clean}
              </span>
            </div>
          )}
        </div>
      )}

      {state.serverShow && (
        <div className="login-forget-form">
          <div className="login-forget-title">{Lang.msg.enterBoxUrl}</div>
          <label className="login-forget-field">
            <input
              autoFocus
              type="text"
              className="login-forget-input"
              placeholder="https://example.com"
              value={state.serverValue}
              onChange={store.setServerValue}
              onKeyDown={store.serverKeyDown}
            />
          </label>

          <div className="flex flex-col items-center gap-8 mt-8">
            <Button
              style={{width: '250px'}}
              size="small"
              textPosition="center"
              onClick={store.serverSubmit}
            >
              {Lang.msg.done}
            </Button>
            <Button
              style={{width: '250px'}}
              size="small"
              textPosition="center"
              onClick={() => store.setServerShow(false)}
            >
              {Lang.msg.close}
            </Button>
          </div>
          {!!state.serverError && (
            <div className="login-forget-error">
              <i className="fi-alert" />
              <span>{state.serverError}</span>
            </div>
          )}
        </div>
      )}
    </div>
  )
})
